import { render, staticRenderFns } from "./DeleteMassPartnerProfitOrderPackage.vue?vue&type=template&id=21f46055&scoped=true&"
import script from "./DeleteMassPartnerProfitOrderPackage.vue?vue&type=script&lang=js&"
export * from "./DeleteMassPartnerProfitOrderPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f46055",
  null
  
)

export default component.exports